import { useContext } from 'react';
import { CompanySettingsContext } from 'src/contexts/company-settings-context';

export const useCompanySettings = () => useContext(CompanySettingsContext);
